import { Link } from "react-router-dom"
import './header.css'
import MenuMobile from "./MenuMobile";
import { useState } from "react";


function HeaderMobile(){
  const [menuOpen, setMenuOpen] = useState(false);
  function Hablitar(){
    setMenuOpen(!menuOpen);
  }
  return(
    
      <div className=" container none ">
      <div className="mobile">
         <Link className="logo" to="/">
            <img src="/favicon.jpg" alt="GolbalTaxi" />
          </Link>
        <div className="icons" onClick={Hablitar}>
          <div className="icon"></div>
          <div className="icon"></div>
          <div className="icon"></div>
        </div>
          
      </div>
      
     
      {menuOpen && <MenuMobile />}
    
    
    </div>

    
   
  )
}
export default HeaderMobile;